import { UserSelect } from "@/containers/Project/components";
import { CONTENT_WIDTH, ProjectUserPermissions } from "@/enums";
import { useProjectContext } from "@/providers";
import { Alert, Col, Form, Row, Typography } from "antd";
import { useIntl } from "react-intl";

interface IProps {
  projectViewers: string[];
  readOnlyMode: boolean;
}

const fieldName = "projectViewers";

export const ProjectViewersTab = ({ projectViewers, readOnlyMode }: IProps) => {
  const intl = useIntl();
  const { canUser } = useProjectContext();

  return (
    <>
      <Typography.Title level={5}>
        {intl.formatMessage({
          id: "project.addViewers",
        })}
      </Typography.Title>
      <Row className="pt-2">
        <Col
          xs={CONTENT_WIDTH.max}
          md={CONTENT_WIDTH.half}
          lg={CONTENT_WIDTH.oneThird}
        >
          <Form.Item
            label={intl.formatMessage({
              id: "project.users",
            })}
            name={fieldName}
            initialValue={projectViewers}
          >
            <UserSelect
              users={projectViewers}
              readOnly={
                !canUser(ProjectUserPermissions.EditProjectRoles) ||
                readOnlyMode
              }
              value={projectViewers}
              limitedOptions={undefined}
              multipleSelect={undefined}
              dataTestId={undefined}
              showDeletedUsers={undefined}
            />
          </Form.Item>
          <Alert
            message={intl.formatMessage({
              id: "project.addViewersDescription",
            })}
            type="info"
          />
        </Col>
      </Row>
    </>
  );
};
